import React, { useState } from 'react';
import styled from 'styled-components';
import arrowDownIcon from 'images/arrow_down-14x8.png';
import SurveyLocationModal from 'components/containers/matching/survey/SurveyLocationModal'
export default function SurveyLocation({items, selectedLocation, setSelectedLocation, onComplete}) {
  const [viewSelectModal, setViewSelectModal] = useState(false);

  const handleOpenModal = (e)=>{
    setViewSelectModal(true);
  }
  const handleCloseModal = (e)=>{
    setViewSelectModal(false);
  }
  const handleSelectLocation = (locationNo) =>{
    let target = items.filter((location)=>{ return parseInt(location['no']) === parseInt(locationNo); });
    if(target.length > 0)
    {
      let targetLocation = target[0];
      setSelectedLocation(targetLocation);
    }
    setViewSelectModal(false);
  }
  const handleNext = (e)=>{
    onComplete();
  }
  return(
    <SurveyWrapper>
      <HeaderWrapper>주로활동하는 지역은<br /> 어디인가요?</HeaderWrapper>
      <BodyWrapper>
        <SelectedPreview onClick={handleOpenModal}>
          {(selectedLocation)
            ?(<PreviewLocation>{selectedLocation['name']}</PreviewLocation>)
            :(<DisabledPreviewLocation>지역 선택</DisabledPreviewLocation>)}
          <ArrowDownBtn>
            <img src={arrowDownIcon} alt={'expand location list button'}/>
          </ArrowDownBtn>
        </SelectedPreview>
      </BodyWrapper>
      {
        (viewSelectModal)
        ?(
          <SurveyLocationModal 
            items={items} 
            selectedLocation={selectedLocation} 
            onCancel={handleCloseModal} 
            onComplete={handleSelectLocation}
          />
        )
        :(null)
      }

      {
        (selectedLocation)
        ?(<CompleteBtn onClick={handleNext}>
        다음
        </CompleteBtn>)
        :(<DisabledCompleteBtn>
        다음
        </DisabledCompleteBtn>)
      }
    </SurveyWrapper>
  );
}

const SurveyWrapper = styled.div`
  padding : calc(100vw * (17.5 / 375)) calc(100vw * (17 / 375)) 0 ;
`;
const HeaderWrapper = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (29 / 375));
  margin-bottom : calc(100vw * (46 / 375));
`;
const BodyWrapper = styled.div`
`
const SelectedPreview = styled.div`
  position: relative;
  height: calc(100vw * (47 / 375));
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 0 calc(100vw * (19 / 375));
`;
const DisabledPreviewLocation = styled.span`
  font-weight: 500;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (45 / 375));
  color: #D0D0D0;
`;
const PreviewLocation = styled.span`
  font-weight: 500;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (45 / 375));
  color: #121212;
`
const ArrowDownBtn = styled.span`
  display: inline-block;  
  height:calc(100vw * (8 / 375));
  width:calc(100vw * (14 / 375));
  position:absolute;
  right:calc(100vw * (19 / 375));
  top:0;
  bottom:0;
  margin:auto;
`;


const CompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #FFCF19;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
`;
const DisabledCompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #D8D8D8;
  color:#989898;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
`;